<template>
  <Transition appear>
    <div v-if="active" class="sign-up-form">
      <div class="form-container">
        <button type="button" @click="store.setNewsLetterPopupState(false)">
          <FaIcon :icon="faXmark" />
        </button>
        <div class="modalContent__image">
          <SvgIcon :src="logoText" />
        </div>
        <div id="mc_embed_signup" class="modalContent__content">
          <form
            id="mc-embedded-subscribe-form"
            action="https://littlearms.us10.list-manage.com/subscribe/post?u=2a572528465ebc2754a1ae238&amp;id=34f03ae350"
            method="post"
            name="mc-embedded-subscribe-form"
            class="validate"
            target="_blank"
            novalidate
          >
            <div id="mc_embed_signup_scroll">
              <label for="mce-EMAIL"
                >Want to stay up-to-date on news related to Little Arms Studios?
                Join our mailing list!</label
              >
              <input
                id="mce-EMAIL"
                type="email"
                name="EMAIL"
                class="email"
                placeholder="Email"
                required
              />
              <div
                style="position: absolute; left: -5000px"
                aria-hidden="true"
              >
                <input
                  type="text"
                  name="b_2a572528465ebc2754a1ae238_34f03ae350"
                  tabindex="-1"
                />
              </div>
              <div class="clear">
                <input
                  id="mc-embedded-subscribe"
                  type="submit"
                  value="Subscribe"
                  name="subscribe"
                  class="button"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { useAppStore } from '@/stores/app';
import FaIcon from '@/components/FaIcon.vue';
import SvgIcon from '@/components/SvgIcon.vue';

import logoTextSvg from '@/assets/images/logo_text.svg?raw';

const store = useAppStore();

const active = computed(() => store.newsLetterPopupActive);
const logoText = computed(() => logoTextSvg);
</script>

<style lang="scss" scoped>
.sign-up-form {
  z-index: 9999;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  background: rgba(255, 255, 255, 0.8);
  opacity: 1;
  transition: opacity 0.5s;

  &.v-enter-from,
  &.v-leave-active {
    opacity: 0;
  }
}

.form-container {
  position: relative;
  border-radius: 10px;
  box-shadow: 0 0 40px 10px rgba(0, 0, 0, 0.2);
  background: linear-gradient(#a1d601, #15bb02, #09ad87);
  color: white;
  width: 600px;
  min-height: 490px;
  animation: formContainer 0.5s both;
  animation-delay: 0.25s;

  > button {
    z-index: 1;
    position: absolute;
    width: 40px;
    height: 40px;
    top: 0;
    right: 0;
    background: transparent !important;
    color: #278a00;
    transform: scale(1);
    transition: 0.25s;

    &:hover {
      color: #0e3100;
      transform: scale(1.3);
    }
  }
}

@keyframes formContainer {
  0% {
    opacity: 0;
    transform: translateY(200px);
  }

  30% {
    transform: translateY(-50px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.modalContent__image {
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  clear: both;
  min-height: 200px;
  width: 100%;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  background-size: 70%;
  color: white;
  padding: 40px 20px;

  .svg-icon {
    fill: currentColor;
    max-width: 100%;
    width: 300px;
  }
}

.modalContent__content {
  clear: both;
  width: 100%;
  padding: 200px 30px 30px;
  margin-left: auto;
  margin-right: auto;

  form {
    > div {
      > label {
        display: block;
        margin-top: 30px;
        word-wrap: break-word;
        text-align: center;
      }

      > .email {
        margin: 30px 0;
        height: 50px;
        width: 100%;
      }

      > .clear {
        text-align: center;

        .button {
          -webkit-appearance: none;
        }
      }
    }
  }
}
</style>
